import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { UserOptions } from 'jspdf-autotable';
import { DocumentRowFilterType, IDocumentRow } from 'models/document-row';
import { convertDocumentRowsToSheet } from './xlsx';
import moment from 'moment';
import { downloadFile } from './apiResponseHelper';

interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}

export const savePdf = (customer: string, filters: { [key in DocumentRowFilterType]?: any }, data: IDocumentRow[], name: string) => {
  const now = moment().format('DD.MM.YYYYTHH_mm_SS');
  const doc = new jsPDF('landscape', 'px', 'a4') as jsPDFWithPlugin;

  const sheet = convertDocumentRowsToSheet(customer, filters, data);
  const head: any = sheet.slice(7, 8);
  const body = sheet.slice(8);

  // Or use javascript directly:
  const marginLeft = 35;
  const marginTop = 30;
  const lineHeight = 14;
  const fontSize = 11;
  doc.text(sheet[0][0] + '', marginLeft, marginTop).setFontSize(fontSize);
  doc.text(sheet[1][0] + '', marginLeft, marginTop + lineHeight).setFontSize(fontSize);
  doc.text(sheet[2][0] + '', marginLeft, marginTop + lineHeight * 2).setFontSize(fontSize);
  doc.text(sheet[3][0] + '', marginLeft, marginTop + lineHeight * 3).setFontSize(fontSize);
  doc.text(sheet[4][0] + '', marginLeft, marginTop + lineHeight * 4).setFontSize(fontSize);
  doc.text(sheet[5][0] + '', marginLeft, marginTop + lineHeight * 5).setFontSize(fontSize);
  doc.autoTable({
    margin: { top: marginTop + lineHeight * 6 },
    didDrawPage: function (d) {
      d.settings.margin.top = 30;
    },
    didParseCell: (cellHook) => {
      if (cellHook.row.index === body.length - 1) {
        cellHook.cell.styles.fontStyle = 'bold';
      }
    }, 
    theme: 'plain',
    head,
    body,
    rowPageBreak: 'avoid'
  });
  const pageCount = doc.getNumberOfPages(); //Total Page Number
  for(let i = 0; i < pageCount; i++) { 
    doc.setPage(i);
    let pageCurrent = doc.getCurrentPageInfo().pageNumber; //Current Page
    doc.setFontSize(10);
    doc.text(pageCurrent + '/' + pageCount, doc.internal.pageSize.width / 2 - 10, doc.internal.pageSize.height - 10);
  }

  const pdfBlob = new Blob([doc.output('arraybuffer')], { type: 'application/pdf' });
  const fileName = name + '_' + now + '.pdf';

  downloadFile(fileName, pdfBlob, window.URL.createObjectURL(pdfBlob))
}